import type { ReactNode } from 'react'
import { NavLink, useSearchParams } from 'react-router-dom'
import { Brand } from './Brand'
import { ConnectedSyncState } from './SyncState'
import { settingsHref } from '../screens/settingsRouting'

export type ScreenKey = 'today' | 'timeline' | 'scoreboard' | 'settings'

const screens: Array<{ key: ScreenKey; label: string }> = [
  { key: 'today', label: 'Today' },
  { key: 'timeline', label: 'Timeline' },
  { key: 'scoreboard', label: 'Scoreboard' },
  { key: 'settings', label: 'Settings' },
]

export function AppShell({ screen, children }: { screen: ScreenKey; children: ReactNode }) {
  const [params] = useSearchParams()
  const syncOverride = params.get('sync') === 'offline' ? 'offline' as const : undefined

  return (
    <div className="app-frame">
      <a className="skip-link" href="#main-content">Skip to content</a>
      <header className="app-header">
        <NavLink to="/?screen=today" className="brand-link" aria-label="Ops Matrix, Today"><Brand /></NavLink>
        <nav className="primary-nav" aria-label="Primary navigation">
          {screens.filter((item) => item.key !== 'settings').map((item) => (
            <NavLink key={item.key} to={`/?screen=${item.key}`} aria-current={screen === item.key ? 'page' : undefined} className={screen === item.key ? 'active' : ''}>
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="header-actions">
          <ConnectedSyncState override={syncOverride} />
          <NavLink to={settingsHref(null, params.toString())} className={`settings-link ${screen === 'settings' ? 'active' : ''}`} aria-label="Settings" aria-current={screen === 'settings' ? 'page' : undefined}>
            <span aria-hidden="true">⚙</span><span className="settings-label">Settings</span>
          </NavLink>
        </div>
      </header>
      <main id="main-content" tabIndex={-1}>{children}</main>
      <nav className="mobile-nav" aria-label="Mobile navigation">
        {screens.map((item) => (
          <NavLink key={item.key} to={item.key === 'settings' ? settingsHref(null, params.toString()) : `/?screen=${item.key}`} aria-current={screen === item.key ? 'page' : undefined} className={screen === item.key ? 'active' : ''}>
            <span aria-hidden="true">{item.key === 'today' ? '✓' : item.key === 'timeline' ? '▦' : item.key === 'scoreboard' ? '▥' : '⚙'}</span>
            {item.label}
          </NavLink>
        ))}
      </nav>
    </div>
  )
}
